"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectWithdrawalFetchResetSmsError = exports.selectWithdrawalFetchResetSms = exports.selectWithdrawalSmsCode = exports.selectPaymentMethodName = exports.selectIsWithdrawalButtonDisabled = exports.selectIsBankCardNumberValid = exports.selectWithdrawalFormDataBankCard = exports.selectCurrentCurrencyListWithdrawalMethod = exports.selectCurrentWithdrawalMethodFields = exports.selectCurrentWithdrawalMethod = exports.selectWithdrawalMethodsLength = exports.selectWithdrawalMethodsByGroupId = exports.selectWithdrawalHistory = exports.selectCreatedWithdrawalError = exports.selectCurrentPaymentAccount = exports.selectPaymentAccountsById = exports.selectCurrentCurrencyListPaymentMethod = exports.selectCurrentMethod = exports.selectCurrentPaymentMethod = exports.selectPaymentMethodsLength = exports.selectPaymentMethodsByGroupId = exports.selectPaymentAccountId = exports.selectPaymentHistory = exports.selectWithdrawModalType = exports.selectPaymentModalType = exports.getPaymentMethodId = exports.selectPaymentMethodsGroupsLoading = exports.selectWithdrawalVerificationId = exports.selectOriginUrl = exports.selectWithdrawalAmount = exports.selectPaymentFetchInfoLoading = exports.selectWithdrawalFetchInfoLoading = exports.selectCreatedWithdrawal = exports.selectWithdrawalFormData = exports.selectWithdrawalMethods = exports.selectCreatedPayment = exports.selectPaymentFormData = exports.selectPaymentSelectedMethodId = exports.selectWithdrawalMethodError = exports.selectWithdrawalFetchInfoError = exports.selectWithdrawalMethodsFetchItemsLoading = exports.selectPaymentMethodsFetchItemsLoading = exports.selectPaymentMethodsFetchItemsError = exports.selectPaymentMethods = exports.getPaymentAccounts = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const selectors_1 = require("../AccountProvider/selectors");
const headers_1 = require("../../utils/api/headers");
const errors_1 = require("../../utils/errors");
const format_1 = require("../../utils/format");
const payment_1 = require("../../utils/payment");
const strings_1 = require("../../utils/strings");
const findTransactionParam_1 = require("../../utils/balance/findTransactionParam");
const constants_1 = require("./constants");
const slice_1 = require("./slice");
const getPaymentHistory = (state) => state.balanceProvider.data.payment.history ||
    slice_1.initialState.data.payment.history;
const getPaymentAccounts = (state) => state.balanceProvider.data.payment.accountsByWithdrawMethods ||
    slice_1.initialState.data.payment.accountsByWithdrawMethods;
exports.getPaymentAccounts = getPaymentAccounts;
const selectPaymentMethods = (state) => state.balanceProvider.data.payment.methods ||
    slice_1.initialState.data.payment.methods;
exports.selectPaymentMethods = selectPaymentMethods;
const getPaymentMethodsGroups = (state) => state.balanceProvider.data.groups.items || slice_1.initialState.data.groups.items;
const selectPaymentMethodsFetchItemsError = (state) => state.balanceProvider.data.payment.methods.fetchItems.error ||
    slice_1.initialState.data.payment.methods.fetchItems.error;
exports.selectPaymentMethodsFetchItemsError = selectPaymentMethodsFetchItemsError;
const selectPaymentMethodsFetchItemsLoading = (state) => state.balanceProvider.data.payment.methods.fetchItems.loading ||
    slice_1.initialState.data.payment.methods.fetchItems.loading;
exports.selectPaymentMethodsFetchItemsLoading = selectPaymentMethodsFetchItemsLoading;
const selectWithdrawalMethodsFetchItemsLoading = (state) => state.balanceProvider.data.withdrawal.methods.fetchItems.loading ||
    slice_1.initialState.data.withdrawal.methods.fetchItems.loading;
exports.selectWithdrawalMethodsFetchItemsLoading = selectWithdrawalMethodsFetchItemsLoading;
const selectWithdrawalFetchInfoError = (state) => state.balanceProvider.data.withdrawal.methods.fetchItems.error ||
    slice_1.initialState.data.withdrawal.methods.fetchItems.error;
exports.selectWithdrawalFetchInfoError = selectWithdrawalFetchInfoError;
const selectWithdrawalMethodError = (state) => state.balanceProvider.data.withdrawal.createData.fetchInfo.error ||
    slice_1.initialState.data.withdrawal.createData.fetchInfo.error;
exports.selectWithdrawalMethodError = selectWithdrawalMethodError;
const selectPaymentSelectedMethodId = (state) => state.balanceProvider.data.payment.methods.selectedId ||
    slice_1.initialState.data.payment.methods.selectedId;
exports.selectPaymentSelectedMethodId = selectPaymentSelectedMethodId;
const selectPaymentFormData = (state) => state.balanceProvider.data.payment.formData ||
    slice_1.initialState.data.payment.formData;
exports.selectPaymentFormData = selectPaymentFormData;
const selectCreatedPayment = (state) => state.balanceProvider.data.payment.createData ||
    slice_1.initialState.data.payment.createData;
exports.selectCreatedPayment = selectCreatedPayment;
const getWithdrawalHistory = (state) => state.balanceProvider.data.withdrawal.history ||
    slice_1.initialState.data.withdrawal.history;
const selectWithdrawalMethods = (state) => state.balanceProvider.data.withdrawal.methods ||
    slice_1.initialState.data.withdrawal.methods;
exports.selectWithdrawalMethods = selectWithdrawalMethods;
const getWithdrawalMethodId = (state) => state.balanceProvider.data.withdrawal.methods.selectedId ||
    slice_1.initialState.data.withdrawal.methods.selectedId;
const selectWithdrawalFormData = (state) => state.balanceProvider.data.withdrawal.formData ||
    slice_1.initialState.data.withdrawal.formData;
exports.selectWithdrawalFormData = selectWithdrawalFormData;
const selectCreatedWithdrawal = (state) => state.balanceProvider.data.withdrawal.createData ||
    slice_1.initialState.data.withdrawal.createData;
exports.selectCreatedWithdrawal = selectCreatedWithdrawal;
const selectWithdrawalFetchInfoLoading = (state) => state.balanceProvider.data.withdrawal.createData.fetchInfo.loading ||
    slice_1.initialState.data.withdrawal.createData.fetchInfo.loading;
exports.selectWithdrawalFetchInfoLoading = selectWithdrawalFetchInfoLoading;
const selectPaymentFetchInfoLoading = (state) => state.balanceProvider.data.payment.createData.fetchInfo.loading ||
    slice_1.initialState.data.payment.createData.fetchInfo.loading;
exports.selectPaymentFetchInfoLoading = selectPaymentFetchInfoLoading;
const selectWithdrawalAmount = (state) => {
    var _a;
    return (_a = state.balanceProvider.data.withdrawal.formData.amount) !== null && _a !== void 0 ? _a : slice_1.initialState.data.withdrawal.formData.amount;
};
exports.selectWithdrawalAmount = selectWithdrawalAmount;
const selectOriginUrl = (state) => {
    var _a;
    return (_a = state.balanceProvider.data.payment.originUrl) !== null && _a !== void 0 ? _a : slice_1.initialState.data.payment.originUrl;
};
exports.selectOriginUrl = selectOriginUrl;
const selectWithdrawalVerificationId = (state) => state.balanceProvider.data.withdrawal.createData.verificationId ||
    slice_1.initialState.data.withdrawal.createData.verificationId;
exports.selectWithdrawalVerificationId = selectWithdrawalVerificationId;
const getWithdrawalSmsCode = (state) => state.balanceProvider.data.withdrawal.createData.smsCode ||
    slice_1.initialState.data.withdrawal.createData.smsCode;
const selectPaymentMethodsGroupsLoading = (state) => {
    return (state.balanceProvider || slice_1.initialState).data.groups.fetchItems.loading;
};
exports.selectPaymentMethodsGroupsLoading = selectPaymentMethodsGroupsLoading;
const getPaymentMethodId = (_state, methodId) => methodId;
exports.getPaymentMethodId = getPaymentMethodId;
const selectPaymentModalType = (state) => state.balanceProvider.layout.paymentModalType ||
    slice_1.initialState.layout.paymentModalType;
exports.selectPaymentModalType = selectPaymentModalType;
const selectWithdrawModalType = (state) => {
    var _a;
    return (_a = state.balanceProvider.layout.withdrawModalType) !== null && _a !== void 0 ? _a : slice_1.initialState.layout.withdrawModalType;
};
exports.selectWithdrawModalType = selectWithdrawModalType;
exports.selectPaymentHistory = (0, toolkit_1.createSelector)([getPaymentHistory], (history) => {
    return {
        ...history,
        items: history.items.map((item) => {
            return { ...item, amount: (0, format_1.adjustAmountForFrontend)(item.amount) };
        }),
    };
});
const selectPaymentAccountId = (state) => state.balanceProvider.data.payment.accountsByWithdrawMethods.selectedId ||
    slice_1.initialState.data.payment.accountsByWithdrawMethods.selectedId;
exports.selectPaymentAccountId = selectPaymentAccountId;
exports.selectPaymentMethodsByGroupId = (0, toolkit_1.createSelector)([exports.selectPaymentMethods, getPaymentMethodsGroups], (methods, paymentMethodsGroups) => (0, payment_1.groupPaymentMethods)({
    methods: methods.items,
    methodGroups: paymentMethodsGroups,
}));
exports.selectPaymentMethodsLength = (0, toolkit_1.createSelector)([exports.selectPaymentMethodsByGroupId], (paymentMethods) => paymentMethods.length);
exports.selectCurrentPaymentMethod = (0, toolkit_1.createSelector)([exports.selectPaymentMethods, exports.selectPaymentSelectedMethodId], (methods, selectedId) => methods.items.find((method) => method.id === selectedId));
// TODO handle it with grouped methods. We will get it from BackEnd
exports.selectCurrentMethod = (0, toolkit_1.createSelector)([exports.selectPaymentSelectedMethodId], (_selectedId) => constants_1.PAYMENT_METHODS.CARD);
exports.selectCurrentCurrencyListPaymentMethod = (0, toolkit_1.createSelector)([exports.selectPaymentMethods, exports.selectPaymentSelectedMethodId], (methods, selectedId) => {
    const currentMethod = methods.items.find((method) => method.id === selectedId);
    if (!currentMethod || !currentMethod.currencyList.length) {
        return {
            minPayment: 0,
            maxPayment: 0,
        };
    }
    else {
        const { minPayment, maxPayment } = currentMethod.currencyList[0];
        return {
            minPayment: (0, format_1.adjustAmountForFrontend)(minPayment || 0),
            maxPayment: (0, format_1.adjustAmountForFrontend)(maxPayment || 0),
        };
    }
});
exports.selectPaymentAccountsById = (0, toolkit_1.createSelector)([exports.getPaymentAccounts, getWithdrawalMethodId], (accounts, selectedId) => !!selectedId && accounts.entries[selectedId]);
exports.selectCurrentPaymentAccount = (0, toolkit_1.createSelector)([exports.selectPaymentAccountsById, exports.selectPaymentAccountId], (selectedAccounts, selectedPaymentAccountId) => selectedAccounts
    ? selectedAccounts.find((account) => account.key === selectedPaymentAccountId)
    : undefined);
exports.selectCreatedWithdrawalError = (0, toolkit_1.createSelector)([exports.selectCreatedWithdrawal], (createData) => (0, errors_1.getErrorsListFormatted)(createData));
exports.selectWithdrawalHistory = (0, toolkit_1.createSelector)([getWithdrawalHistory], (history) => {
    return {
        ...history,
        items: history.items.map((item) => ({
            ...item,
            amount: (0, format_1.adjustAmountForFrontend)(item.amount),
        })),
    };
});
exports.selectWithdrawalMethodsByGroupId = (0, toolkit_1.createSelector)([exports.selectWithdrawalMethods, getPaymentMethodsGroups], (methods, paymentMethodsGroups) => (0, payment_1.groupPaymentMethods)({
    methods: methods.items,
    methodGroups: paymentMethodsGroups,
}));
exports.selectWithdrawalMethodsLength = (0, toolkit_1.createSelector)([exports.selectWithdrawalMethodsByGroupId], (withdrawalMethods) => withdrawalMethods.length);
exports.selectCurrentWithdrawalMethod = (0, toolkit_1.createSelector)([exports.selectWithdrawalMethods, getWithdrawalMethodId], (methods, selectedId) => methods.items.find((method) => method.id === selectedId));
const CURRENT_WITHDRAWAL_METHOD_FILEDS_EMPTY_ARRAY = [];
exports.selectCurrentWithdrawalMethodFields = (0, toolkit_1.createSelector)(exports.selectCurrentWithdrawalMethod, (method) => {
    if (method === undefined) {
        return CURRENT_WITHDRAWAL_METHOD_FILEDS_EMPTY_ARRAY;
    }
    return method.withdraw_params
        .map((param) => param.type && constants_1.METHODS_FOR_MAPPING_FIELDS[param.type])
        .filter(Boolean);
});
exports.selectCurrentCurrencyListWithdrawalMethod = (0, toolkit_1.createSelector)([exports.selectWithdrawalMethods, getWithdrawalMethodId], (methods, selectedId) => {
    const currentMethod = methods.items.find((method) => method.id === selectedId);
    if (!currentMethod || !currentMethod.currencyList.length) {
        return {
            minWithdraw: 0,
            maxWithdraw: 0,
        };
    }
    else {
        const { minWithdraw, maxWithdraw } = currentMethod.currencyList[0];
        return {
            minWithdraw: (0, format_1.adjustAmountForFrontend)(minWithdraw || 0),
            maxWithdraw: (0, format_1.adjustAmountForFrontend)(maxWithdraw || 0),
        };
    }
});
const selectWithdrawalFormDataBankCard = (state) => (0, exports.selectWithdrawalFormData)(state).card;
exports.selectWithdrawalFormDataBankCard = selectWithdrawalFormDataBankCard;
exports.selectIsBankCardNumberValid = (0, toolkit_1.createSelector)([exports.selectCurrentWithdrawalMethod, exports.selectWithdrawalFormDataBankCard], (currentWithdrawalMethod, bankCardNumber) => (currentWithdrawalMethod &&
    !!(0, findTransactionParam_1.findTransactionParam)(currentWithdrawalMethod === null || currentWithdrawalMethod === void 0 ? void 0 : currentWithdrawalMethod.withdraw_params, betweb_openapi_axios_1.MethodParameterType.CardNumber) &&
    (bankCardNumber === null || bankCardNumber === void 0 ? void 0 : bankCardNumber.length) !== 16) ||
    false);
exports.selectIsWithdrawalButtonDisabled = (0, toolkit_1.createSelector)([
    exports.selectWithdrawalFetchInfoLoading,
    selectors_1.selectAccountBalance,
    exports.selectWithdrawalAmount,
    exports.selectIsBankCardNumberValid,
], (isLoading, accountBalance, amount, IsBankCardNumberValid) => isLoading || accountBalance < Number(amount) || IsBankCardNumberValid);
exports.selectPaymentMethodName = (0, toolkit_1.createSelector)([exports.selectPaymentMethods, exports.selectWithdrawalMethods, exports.getPaymentMethodId], (paymentMethods, withdrawalMethods, methodId) => {
    var _a;
    return ((_a = [...paymentMethods.items, ...withdrawalMethods.items].find((method) => method.id === methodId)) === null || _a === void 0 ? void 0 : _a.name) || methodId;
});
exports.selectWithdrawalSmsCode = (0, toolkit_1.createSelector)([getWithdrawalSmsCode], (smsCode) => (smsCode ? (0, strings_1.padNumber)(smsCode) : smsCode));
exports.selectWithdrawalFetchResetSms = (0, toolkit_1.createSelector)([exports.selectWithdrawalMethodError], (error) => +(0, headers_1.getHeadersFetch)(error, 'retry-after'));
exports.selectWithdrawalFetchResetSmsError = (0, toolkit_1.createSelector)([exports.selectWithdrawalMethodError], (errors) => {
    var _a, _b, _c, _d;
    const code = (_c = (_b = (_a = errors === null || errors === void 0 ? void 0 : errors.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors[0]) === null || _c === void 0 ? void 0 : _c.code;
    if (code) {
        const title = (_d = constants_1.ALL_WITHDRAW_ERROR_MESSAGES[code]) !== null && _d !== void 0 ? _d : 'error';
        const error = {
            title,
            code,
        };
        return error;
    }
    else {
        return null;
    }
});
//# sourceMappingURL=selectors.js.map